import Vue from "vue";

import websocket from "@/utils/websocket/index";
export const securityConfig = {
  methods: {
    //TODO：获取全部安全检查类型
    async getCheckTypeAll(obj) {
      let { pageSize, pageNum, name } = obj;
      let res = await this.$http.get("/tenant/check/type/list", {
        pageSize,
        pageNum,
        name: name ?? null,
      });
      return res || [];
    },
    //TODO：根据typeid去获取检查类型及组合条目
    async getCheckTypeid(obj) {
      let { pageSize, pageNum, typeId } = obj;
      let res = await this.$http.get("/tenant/check/group/list", {
        typeId: typeId,
        pageSize: pageSize,
        pageNum: pageNum,
      });
      return res || [];
    },

    //TODO:新增检查表类型
    async addCheckType(obj) {
      let res = await this.$http.post("/tenant/check/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改检查表类型
    async upCheckType(obj) {
      console.log(obj, '111111111111');
      let res = await this.$http.put("/tenant/check/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        this.dialogConfig.dialogVisible = false;
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:删除检查表类型
    async delCheckType(obj) {
      let res = await this.$http.delete(`/tenant/check/type/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        this.dialogConfig.dialogVisible = false;
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改检查表的人员和定时任务
    async upCheckTypeUser(obj) {
      let res = await this.$http.put(`/tenant/check/type/patrolUser`, obj);
      // if (res.code == 200) {
      //   this.$message({ message: res.msg, type: "success" });
      //   this.dialogConfig.dialogVisible = false;
      // } else {
      //   this.$message.error(res.msg);
      // }
      return res;
    },
    //TODO:新增项目名称
    async addGropName(obj) {
      let res = await this.$http.post("/tenant/check/group", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改项目名称
    async upGropName(obj) {
      let res = await this.$http.put("/tenant/check/group", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO:删除项目名称
    async delGropName(obj) {
      let res = await this.$http.delete(`/tenant/check/group/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },

    //TODO:新增检查内容
    async addGroupsItems(obj) {
      let res = await this.$http.post("/tenant/check/items", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 上传检查内容文件
    async addGroupsItemsFiles(fetchForm) {
      let res = await this.$http.post(`/tenant/file/check/items`, fetchForm, {
        "Content-Type": "multipart/form-data",
      });
      return res;
    },

    //TODO：更新检查内容
    async upGroupItems(val) {
      let res = await this.$http.put("/tenant/check/items", val);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    
    //TODO：删除检查内容
    async delGroupItemss(obj) {
      let res = await this.$http.delete(`/tenant/check/items/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    async getCheckContent(id) {
      let res = await this.$http.get(`/tenant/check/items/${id}`);
      return res.data;
    },
    //TODO:检查项的详细信息
    async getCheckItemsID(id) {
      let res = await this.$http.get(`/tenant/check/record/item/${id}`);
      return res.data;
    },
    //TODO: 上传安全检查图片
    async uploadCheckFile(obj, files) {
      //TODO:type(1 整改前  2 整改后)
      let val = {
        itemsId: obj.id,
      };
      let formData = new FormData();
      Object.keys(val).forEach((keys) => {
        formData.append(keys, val[keys]);
      });
      files.forEach(async (item) => {
        formData.append("file", item.raw);
      });
      let res = await this.$http.post(
        "/tenant/file/check/record/items/photo",
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );
      //TODO:上传图片
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 检查人员配置
    async handle_employee(obj, typeid, employeeList) {
      let user = {
        id: typeid,
        patrolUserId: employeeList[0].id,
      };
      let res = await this.$http.put("/tenant/check/type/patrolUser", user);
      if (res.code == 200) {
        this.$message({ message: "设置检查人员成功", type: "success" });
        this.dialogConfig.dialogVisible = false;
      } else {
        this.$message.error("设置检查人员失败");
      }
    },
    //TODO：保存安全检查内容
    async saveCheckInfo(obj) {
      let res = await this.$http.put("/tenant/check/record", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：获取当前登录人的安全检查任务
    async getCheckTask(employeeid, typeId, checkRecordNo,pageNum, pageSize) {
      let res = await this.$http.get("/tenant/check/record/list", {
        typeId: typeId == 0 ? "" : typeId,
        checkRecordNo: checkRecordNo ?? null, 
        pageSize: pageSize,
        pageNum: pageNum,
      });
      return res || [];
    },
    //TODO: 删除安全检查
    async delCheck(id) {
      let res = await this.$http.delete(`/tenant/check/record/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：根据检查记录id查询检查任务
    async getCheckTaskById(id) {
      let res = await this.$http.get(`/tenant/check/record/${id}`);
      return res || [];
    },
    //TODO: 根据检查记录id查询隐患
    async getCheckTaskByCheckRecordId(id) {
      let res = await this.$http.get(`/tenant/dangers/record/list/by/checkRecord/${id}`);
      return res ;
    },
    //TODO：修改表类型的派发方式
    async upCheckTypeMethod(obj) {
      let res = await this.$http.put("/check/upchecktypeMethod", obj);
      if (res.status == 0) {
        this.$message({ message: "修改派发方式成功！", type: "success" });
        return true;
      } else {
        this.$message.error("修改失败！");
        return false;
      }
    },
    //TODO: 派发任务(新增检查记录)
    async send_Check(obj) {
      let res = await this.$http.post("/tenant/approve/initiate", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        this.dialogConfig.dialogVisible = false;
      } else {
        this.$message.error(res.msg);
      }
    },

    //TODO：修改审批流程
    async upaudit_process(trans_type, arr) {
      // let filteredArr = arr.filter((item) => item.employeeId);
      // if (filteredArr.length == 0) return this.$message.error("请配置审核人员");

      let res = await this.$http.put("/tenant/process/step", {
        processConfigType: trans_type,
        processStepList: arr,
      });

      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },

    //TODO: 获取区域
    async getAreaList(obj) {
      let { pageSize, pageNum, areaId, dateType } = obj;

      let res = await this.$http.get("/tenant/check/area/list", {
        areaId: areaId ?? null,
        dateType: dateType ?? null,
        pageSize: pageSize,
        pageNum: pageNum,
      });
      return res || [];
    },
    //TODO：修改区域
    async upArea(obj) {
      let res = await this.$http.put("/tenant/check/area", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        return true;
      } else {
        this.$message.error(res.msg);
        return false;
      }
    },
    //TODO：新增区域
    async addArea(obj) {
      let res = await this.$http.post("/tenant/check/area", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        return true;
      } else {
        this.$message.error(res.msg);
        return false;
      }
    },
    //TODO：删除区域
    async delArea(id) {
      let res = await this.$http.delete(`/tenant/check/area/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        return true;
      } else {
        this.$message.error(res.msg);
        return false;
      }
    },

    //TODO：获取选择日期的排班
    async getCheckSchedule(checkTime) {
      let res = await this.$http.get("/tenant/plan/list/by/date", {
        checkTime: checkTime ?? "",
      });
      return res;
    },
    //TODO：排班新增区域
    async addScheduleArea(obj) {
      let res = await this.$http.post("/tenant/area", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        return true;
      } else {
        this.$message.error(res.msg);
        return false;
      }
    },
    //TODO：排班修改区域名称
    async upScheduleArea(obj) {
      let res = await this.$http.put("/tenant/area", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        return true;
      } else {
        this.$message.error(res.msg);
        return false;
      }
    },
    //TODO：删除排班区域
    async delScheduleArea(id) {
      let res = await this.$http.delete(`/tenant/area/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
        return true;
      } else {
        this.$message.error(res.msg);
        return false;
      }
    },
    //TODO：获取公用区域列表
    async getScheduleAreaList() {
      let res = await this.$http.get("/tenant/area/list");
      return res;
    },

    //TODO: 校验本月是否有排班
    async eachMonthSched(date) {
      let res = await this.$http.post("/tenant/plan/has/generated", {
        date: date,
      });

      return res;
    },
    //TODO: 删除某月的排班计划
    async delhMonthSched(date) {
      let res = await this.$http.post("/tenant/plan/del/by/month", {
        date: date,
      });

      return res;
    },
    //TODO: 生成本月排班
    async genMonthSched(date) {
      let res = await this.$http.post("/tenant/plan/generate", {
        date: date,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 获取排班表定时任务
    async getPlanTaskList() {
      let res = await this.$http.get("/tenant/job/plan");
      return res.data;
    },
    //TODO： 修改排班表定时任务
    async updatePlanTask(obj) {
      let res = await this.$http.put("/tenant/job", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 新增临时检查任务
    async addPlan(obj) {
      let res = await this.$http.post("/tenant/plan", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },


    
    //TODO:修改临时检查任务
    async updateConstruction(obj) {
      let res = await this.$http.put("/tenant/plan/construction", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改临时检查任务
    async upPlan(obj) {
      let res = await this.$http.put("/tenant/plan", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:删除临时检查任务
    async delPlan(id) {
      let res = await this.$http.delete(`/tenant/plan/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:删除临时检查任务
    async delPlan2(id) {
      let res = await this.$http.delete(`/tenant/plan/construction/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:排班复制
    async copyToTems(obj) {
      let res = await this.$http.post(`/tenant/plan/copy`, obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 手动派发任务（不签到）
    async sendChecks(id) {
      let res = await this.$http.post(`/tenant/plan/start/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 手动派发任务（需要签到）

    async sendChecks2(obj) {
      let res = await this.$http.post(`/tenant/plan/start2`, obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 获取签到计划
    async getCardRecords(obj) {
      let { pageSize, pageNum, areaName } = obj;
      let res = await this.$http.get("/tenant/check/sign/record/list",{
        areaName:areaName ?? null,
        pageNum,
        pageSize,
      });
      return res;
    },
    //TODO: 通过签到计划id获取签到记录情况
    async getCardRecordsItems(id) {
      let res = await this.$http.get(`/tenant/check/sign/record/${id}`);
      return res;
    },
    //TODO:删除签到计划
    async delCardRecords(id) {
      let res = await this.$http.delete(`/tenant/check/sign/record/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:删除签到信息
    async delCardRecordsItems(id) {
      let res = await this.$http.delete(`/tenant/check/sign/record/person/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改签到状态
    async upCardRecordsStatus(obj) {
      let { id, status } = obj;
      let res = await this.$http.put("/tenant/check/sign/record/status", {
        id: id ?? null,
        status: status ?? null,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:修改启动计划是否打卡任务状态
    async upCardStatus(obj) {
      let { jobId, status } = obj;
      let res = await this.$http.put("/tenant/ism/check/plan/update/job", {
        id: jobId ?? null,
        status: status ?? null,
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO: 获取安全检查汇总信息
    async getCheckSummary(obj) {
      let { pageSize, pageNum, createTime } = obj;

      let res = await this.$http.get("/tenant/check/collect/list", {
        createTime: createTime ?? null,
        pageSize: pageSize,
        pageNum: pageNum,
      });
      return res || [];
    },
    //TODO: 删除安全检查汇总信息
    async delCheckSummary(id) {
      let res = await this.$http.delete(`/tenant/check/collect/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO： 根据汇总列表id查询汇总信息
    async getCheckSummaryById(id) {
      let res = await this.$http.get(`/tenant/check/collect/record/info/${id}`);
      return res;
    },
    //TODO: 安全检查提交汇总审核
    async summarySumbitApprove(id) {
      let res = await this.$http.post(`/tenant/check/collect/approve/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //获取安全检查轨迹
    async getCheckTrack(checkId) {
      let res = await this.$http.get(`/tenant/track/getCheckTrack`, {
        checkId: checkId,
      });
      return res;
    },
  },
};
